import { Badge } from "@/components/ui/badge";
import { MapPin, Wifi } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Shared "Munich in-person" / "Online available" badge row.
 * Used on /view-plans and every individual service page so users
 * can see at a glance where a service is delivered.
 */
export const AvailabilityBadges = ({
  inPerson = true,
  online = false,
  align = "start",
  className,
}: {
  inPerson?: boolean;
  online?: boolean;
  align?: "start" | "center";
  className?: string;
}) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid="availability-badges"
      className={`flex flex-wrap gap-2 ${align === "center" ? "justify-center" : "justify-start"} ${className ?? ""}`}
    >
      {inPerson && (
        <Badge variant="secondary" className="gap-1">
          <MapPin className="h-3 w-3" /> {t("availability.inPersonMunich")}
        </Badge>
      )}
      {online && (
        <Badge variant="outline" className="gap-1">
          <Wifi className="h-3 w-3" /> {t("availability.online")}
        </Badge>
      )}
    </div>
  );
};

export default AvailabilityBadges;

